import { useTranslation } from "next-i18next";
import React from "react";
import { Heading2 } from "../common/standard/headings/Heading";
import { Separator } from "../ui/separator";

const WhatsNew = ({ hideSeprator = false }: any) => {
  const { t } = useTranslation("layout");
  return (
    <div className="p-3 text-sm  mx-auto">
      {/* {hideSeprator ? "" : <Separator />} */}
      <div className="font-bold text-xl">{t("WhatsNew.heading")}</div>
      <div className="text-base mt-[1px] ">{t("WhatsNew.subHeading")}</div>
      {/* <Separator /> */}
      <div className="grid text-muted-foreground mt-7">
        <div className="mb-3">
          <span className="font-semibold">
            {t("WhatsNew.details.one.heading")}
          </span>
          {t("WhatsNew.details.one.text")}
        </div>
        {/* <div className="mb-3">
          <span className="font-semibold">
            {t("WhatsNew.details.two.heading")}
          </span>
          {t("WhatsNew.details.two.text")}
        </div> */}
        <div className="mb-3">
          <span className="font-semibold">
            {t("WhatsNew.details.three.heading")}
          </span>
          {t("WhatsNew.details.three.text")}
        </div>
        <div className="mb-3">
          <span className="font-semibold">
            {t("WhatsNew.details.four.heading")}
          </span>
          {t("WhatsNew.details.four.text")}
        </div>
        {/* <div className="mb-3">
          <span className="font-semibold">
            {t("WhatsNew.details.five.heading")}
          </span>
          {t("WhatsNew.details.five.text")}
        </div> */}
        <div className="mb-3">
          <span className="font-semibold">
            {t("WhatsNew.details.six.heading")}
          </span>
          {t("WhatsNew.details.six.text")}
        </div>
      </div>
    </div>
  );
};

export default WhatsNew;
